import { linkToTeacherDashboard } from "../../links";

export const PRESELECT_CLASSES_PARAM_KEY = "preselectClasses";
export type PreselectClassesOption = "all" | "synced" | "unsynced";

export function linkToClassesPage({
  preselectClasses: preselectAllClasses
}: { preselectClasses?: PreselectClassesOption } = {}) {
  const preselectAllClassesQueryParam = preselectAllClasses
    ? `?${PRESELECT_CLASSES_PARAM_KEY}=${preselectAllClasses}`
    : "";

  return `${linkToTeacherDashboard()}/classes${preselectAllClassesQueryParam}`;
}
